import { MARGIN } from '@/domain/dienstplan/features/VisualEditor/constants';
import { SharedContext } from '@/domain/dienstplan/features/VisualEditor/hooks/useVisualEditor/types';
import { Point } from '@/domain/dienstplan/features/VisualEditor/types';
import { getIntervalByMousePosition } from '@/domain/dienstplan/features/VisualEditor/utils/mouseHelper/getIntervalByMousePosition';
import { snapToQuarterHour } from '@/domain/dienstplan/features/VisualEditor/utils/mouseHelper/snapToQuarterHour';

export function showPopover({
  ctx,
  event,
  point,
}: {
  ctx: SharedContext;
  event: React.MouseEvent<SVGRectElement, MouseEvent>;
  point: Point;
}) {
  const el = event.target as SVGRectElement;
  const editor = document.getElementById('visual-editor');
  const offsetX = editor?.getBoundingClientRect().x ?? 0;
  const offsetY = editor?.getBoundingClientRect().y ?? 0;

  ctx.store.setPopoverPosition({
    position: 'absolute',
    left: `${el.getBoundingClientRect().x - offsetX + 10}px`,
    top: `${el.getBoundingClientRect().bottom - offsetY - 10}px`,
  });

  const belegung = getIntervalByMousePosition(
    ctx.belegungen
      .filter((r) => r.mode === 'inactive')
      .filter(
        (r) => r.belegung.arbeitsbereich.id === ctx.selectedArbeitsbereich.id,
      ),
    {
      x: snapToQuarterHour(ctx.xScaleAxis.invert(point.x - MARGIN.left)),
      y: ctx.yScaleAxis.invert(point.y - MARGIN.top),
    },
  );

  if (belegung) {
    if (belegung?.belegung?.id !== ctx.store.ui.hoveredBelegung?.id) {
      ctx.store.setIsPopoverOpen(false);
    }
    ctx.store.setHoveredBelegung(belegung.belegung);
  }
}
